<template>
	<div class>
		<!-- Modal Component -->
		<ModalBox
			v-model="legacyModalVisible"
			placement="left"
			size="md"
			hide-close
			header-class="!hidden"
			:wrapper-classes="'add-platform'"
		>
			<div class="modal-container">
				<div class="px-3 mb-2 flex flex-wrap items-start">
					<div class="mt-3 w-3/4">
						<h3 class="add-platform-title mt-2 mb-4 sm:flex items-center">
							Add Stream within Castr
							<Tooltip content="You can select streams within Castr as custom destination for pre-recorded stream.">
								<IconBase width="14" height="15" fill="none" class="text-dark-9 ml-2">
									<IconInfo />
								</IconBase>
							</Tooltip>
						</h3>
					</div>
					<div class="mt-3 text-right w-1/4">
						<FormButton
							type="light" :isIcon="true"
							class="px-2"
							@click="dismiss"
						>
							<img
								src="@/assets/images/menu-close.svg"
								alt="Menu close"
							>
						</FormButton>	
					</div>
				</div>
				<div class="px-3 flex flex-wrap items-start">
					<!-- Case total destination -->
					<div class="w-full">
						<Alert type="normal" class="flex p-2 mb-3" v-if="platformUsage && platformUsage.totalDestination">
							<div>
								<span class="text-dark-9 text-s-m text-500 m-0">You have used {{  platformUsage.usedDestination}}/{{ platformUsage.totalDestination}} destinations.</span>
								<span class="text-dark-7 text-s-s font-normal m-0"> Need more? <a class="text-underline text-dark-8" target="_blank" href="/app/subscribe">Upgrade</a> here.</span>
							</div>
						</Alert>
					</div>
					<!-- Case unique/extra destination -->
					<div class="w-full">
						<Alert type="normal" class="flex p-2 mb-3" v-if="platformUsage && platformUsage.uniqueDestination && platformUsage.uniqueDestination.limit">
							<div>
								<span class="text-dark-9 text-s-m text-500 m-0">You have used {{  platformUsage.uniqueDestination.used}}/{{ platformUsage.uniqueDestination.limit}} unique destinations and {{ platformUsage.extraDestination.used}}/{{ platformUsage.extraDestination.limit}} extra ones<span v-if="getStreamtype()"> across all {{ getStreamtype() }}</span>.</span>
								<span class="text-dark-7 text-s-s font-normal m-0"> Need more? <a class="text-underline text-dark-8" target="_blank" href="/app/subscribe">Upgrade</a> here.</span>
							</div>
						</Alert>
						<Alert
							v-if="dismissCountDown"
							type="error"
							closeIcon
							class="flex items-center p-2 mb-3"
						>
							Please upgrade your subscription to add more streams.
						</Alert>
					</div>
				</div>
				<div class="px-3 flex flex-wrap items-start">
					<div class="w-full">
						<div class="relative search-form order-0 md:order-1 mb-3 md:mb-0 flex items-center">
							<IconBase class="absolute z-10 left-2 text-dark-7 top-1/2 -translate-y-1/2">
								<IconSearch />
							</IconBase>
							<FormInput
								ref="searchWidgetInputElement"
								v-model="searchWidgetInput"
								placeholder="Search for streams"
								class="mb-4"
								customClasses="!bg-transparent !border-0 !pl-10 !pr-4"
							/>
						</div>
					</div>
				</div>
				<div class="px-3 flex flex-wrap">
					<div class="w-full">
						<div class="grid-wrapper">
							<div
								v-for="(categoryName, index) in streamCategoryList"
								:key="index"
								class="mb-3 md:mb-5"
							>
							<FormButton
								:aria-controls="categoryName+'-streams'"
								:class="categoryCollapseHash[categoryName] ? null : 'collapsed'"
								type="link"
								:aria-expanded="categoryCollapseHash[categoryName] ? 'true' : 'false'"
								class="text-reset pl-4 font-normal btn-category"
								@click="categoryCollapseHash[categoryName] = !categoryCollapseHash[categoryName]">
									<img
										:src="getCategoryIcon(categoryName)"
										:alt="categoryName+'streams'"
										class="mr-2"
									>
									<span class="mr-2">{{ categoryNameMaps[categoryName] || categoryName }}</span> 
									<Tooltip :active="!!getStreamnumber(categoryName)">
										<Badge type="main" class="stream-count text-500" pill>{{ streamFilter(categoryName).length }}{{ getStreamnumber(categoryName) }}</Badge>
										<template #content>
											<span class="text-dark-8 text-small">
												You have created {{ streamFilter(categoryName).length }}{{ getStreamnumber(categoryName) }} streams. Need more? <a class="text-underline text-white" target="_blank" href="/app/subscribe">Upgrade here</a>
											</span>
										</template>
									</Tooltip>
								</FormButton>
								<div v-show="categoryCollapseHash[categoryName]" class="mt-3" :id="categoryName+'streams'">
									<ul class="flex flex-col gap-2">
										<li v-for="stream in streamFilter(categoryName)"
										:key="stream._id"
										class="grid-item">
											<div @click="toggleChoose(stream)" class="!p-2 rounded cursor-pointer" :class="{'bg-main': isChosen(stream)}">
												<stream-card-view
													:stream="stream"
													:compact-mode="true"
													:light-mode="true"
													:chosenStreams="chosenStreams"
													hide-preview
												/>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="px-3 flex flex-wrap items-start">
					<div class="w-full">
						<FormButton :disabled="chosenStreams.length === 0" v-if="!loading" type="main" size="md" class="mt-4 justify-center" fullWidth @click="addWithinCast">Save</FormButton>
						<FormButton disabled v-else type="main" size="md" class="mt-4 w-full">
							<Spinner text="Saving..." classes="text-dark-8" spinner-color="var(--c-dark-8)" spinner-size="15px" />
						</FormButton>
					</div>
				</div>
			</div>
		
</ModalBox>

		<alert-modal
			:description="`Please add Castr application to your Facebook Group '${selectedSubChannel && selectedSubChannel.name}' to connect with Castr`"
			modal-id="modal-facebook-groups-guide"
			message="Please add Castr app to your Facebook Group (Settings -> Manage Advanced Settings -> Apps) or check your permission to stream to Group on Facebook. If you still encounter a problem, please contact our support team."
			ok-text="Close"
			ok-href="https://web.facebook.com/help/261149227954100?_rdc=1&_rdr"
		/>
	</div>
</template>

<script>
import ModalBox from './ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import Tooltip from '@/components/Atoms/Tooltip.vue'
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Spinner from "@/components/ui/Spinner.vue";
import StreamService from '@/services/StreamService';
import AlertModal from '@/components/modals/AlertModal.vue';
import Alert from '@/components/Atoms/Alert.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import StreamCardView from '@/components/ui/StreamCardView.vue';
import SubscriptionService from '@/services/SubscriptionService';
import FormButton from '@/components/Atoms/FormButton.vue';
import Badge from '@/components/Badge.vue';
import FormInput from '@/components/Atoms/FormInput.vue';
import IconBase from '@/components/icon/IconBase.vue';
import IconSearch from '@/components/icon/IconSearch.vue';
import IconInfo from '@/components/icon/IconInfo.vue';
import { track, EVENTS } from '@/lib/tracking';

export default {
	name: 'AddCastrStreamModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-castr-stream',
	components: {
		ModalBox,
		Tooltip,
		FormButton,
		FormInput,
		IconBase,
		IconSearch,
		IconInfo,
		Alert,
		AlertModal,
		ConfirmModal,
		Spinner,
		StreamCardView,
		Badge
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		platformAdded: Boolean,
		platformDeleted: Boolean,
		platformCastrFiltered: null,
		platformUsageData: Object
	},
	data() {
		return {
			streams: [],
			oauthProcessing: false,
			chosenServer: null,
			stage: 0,
			processing: false,
			error: null,
			serviceLinkError: false,
			serviceLinkConflict: false,
			platformServerInputMode: null,
			configRequired: false,
			linkedServiceCreds: null,
			loading: false,
			serviceLinkProcessing: false,
			platform: { enabled: false, configurableMetadata: {} },
			selectedSubChannel: null,
			customPlatform: false,
			// platformTemplates: Platforms,
			platformTemplates: [],
			platformListProcessing: false,
			serviceResponseRecieved: false,
			formErrors: { server: false, streamKey: false },
			oauthConnectId: null,
			isAuthRequired: false,
			rtmpAuthUsername: '',
			rtmpAuthPassword: '',
			streamCreateDropdownActive: false,
			maxLengthTitle: 1000,
			maxLengthDescription: 5000,
      showTitleLimitTracking: false,
			searchWidgetInput: '',
			isSchedulerInfiniteLoop: false,
			platformUsage: null,
			categoryCollapseHash: {
				restream: true,
				live: true,
				vod: true,
				ipcam: true,
			},
			categoryNameMaps: {
				live: 'Livestreams',
				restream: 'Multistream',
				ipcam: 'IP Camera',
				vod: 'Video Hosting',
			},
			userSubscription: null,
			chosenStreams: [],
			dismissSecs: 10,
			dismissCountDown: 0,
		};
	},
	computed: {
		...mapGetters({
			baseSubscription: 'User/baseSubscription',
			addonSubscriptions: 'User/addonSubscriptions'
		}),
		user() {
			return this.$store.state.User;
		},
		streamCategoryList() {
			const cats = {};
			if (this.stream.type === 'subsecond') {
				this.streams.forEach(s => {
				if (s.type === 'live') cats[s.type] = s.sortOrder;
			});
			} else {
				this.streams.forEach(s => {
				if(s.type != 'vod' && s.type != 'scheduled' && s.type != 'ipcam' && s.type != 'tvplayout' && s.type != 'subsecond')
				cats[s.type] = s.sortOrder;
			});
			}
			let categoryList = Object.keys(cats).sort(
				(cat1, cat2) => cats[cat1] > cats[cat2]
			);
			categoryList = _.sortBy(categoryList, cat => cats[cat]);

			return categoryList;
		},
		canSave() {
			const validStage = this.stage > 0;
			return validStage;
		},
		streamFilter() {
			return categoryName => {
				const filteredStreams = this.streams.filter(s => {
					if (this.stream._id === s._id) return false
					let bool = s.type === categoryName;
					if (bool && this.searchWidgetInput) {
						const searchStr = this.searchWidgetInput.toLowerCase();
						bool = s.name.toLowerCase().includes(searchStr);
					}
					return bool;
				});

				return filteredStreams;
			};
		},
		activeTeam(){
			return this.$store.state.User.activatedTeam;
		}
	},
	watch: {
		platformAdded: async function() {
			const platformUsage = await StreamService.getPlatformUsage(this.stream.type);
			if(platformUsage) this.platformUsage = platformUsage;
		},
		platformDeleted: async function() {
			this.fetchPlatformUsage();
			try {
				const streamObj = await StreamService.getStream(this.stream._id);
				this.streams = this.streams.map((stream) => {
					const addedStream = streamObj.platforms.find(({ streamObject }) => {
						if (streamObject) return streamObject._id === stream._id
					})
					if (addedStream) {
						stream.added = true
					} else stream.added = false
					return stream
				})
			} catch (error) {
				console.log(error);
			}
		},
		platformUsageData: function(){
			this.platformUsage = this.platformUsageData;
		},
		isAuthRequired: function(isRequired) {
			if (!isRequired) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
			} else {
				this.rtmpAuthUsername = '';
				this.rtmpAuthPassword = '';
			}
		},
	},
	async mounted() {
		try {
			// Use streams from Vuex store (already loaded at app level)
			await this.$store.dispatch('Streams/getStreams'); // Will skip if already loaded
			const streams = this.$store.getters['Streams/streams'];
			
			setTimeout(() => {
				// Use cloneDeep to prevent Vuex mutation errors
				this.streams = _.cloneDeep(streams);
				this.loading = false;
				this.userSubscription = { subscription: this.baseSubscription, addonSubscriptions: this.addonSubscriptions}

				this.streams.map((stream) => {
					const addedStream = this.stream.platforms.find(({ streamObject }) => {
					if (streamObject) return streamObject._id === stream._id
				})
				if (addedStream) stream.added = true
				return stream
				})
			}, 100);
		} catch (err) {
			this.$notify({ group: 'error', title: err.error, text: err.message });
			this.loading = false;
			return;
		}
	},
	methods: {
		onLegacyModalShow() {
			this.onInit();
		},
		onLegacyModalHide() {
			this.onDismiss();
		},
		onLegacyModalHidden() {
			this.clearChosenStreams();
		},
		async onInit() {
		},
		getCategoryIcon(categoryName) {
			return require(`@/assets/icons/stream-type-${categoryName}-ico.svg`); // eslint-disable-line no-undef
		},
		getStreamnumber(type) {
				let streamCountarray = []
				if(this.userSubscription.subscription && this.userSubscription.subscription.enabled && this.userSubscription.subscription.package.category == type){
					let streamCountoverride = _.get(this.userSubscription.subscription, ['definitionOverride', 'streams']);
					if(streamCountoverride){
						streamCountarray.push(streamCountoverride);
					}else{
						streamCountarray.push(_.get(this.userSubscription.subscription, ['package', 'definition', 'streams']));
					}
				}
				const typeFilteredaddonsub = _.map(this.userSubscription && this.userSubscription.addonSubscriptions, function(single){
					if(single.enabled && single.category == type){
						let streamCountoverride = _.get(single, ['definitionOverride', 'streams']);
						if(streamCountoverride){
							streamCountarray.push(streamCountoverride);
						}else{
							streamCountarray.push(_.get(single, ['package', 'definition', 'streams']));
						}
					}
				})
				if(streamCountarray.length) return '/'+(streamCountarray.length > 1 ? Math.max.apply(Math, streamCountarray) : streamCountarray[0]);
		},
		getStreamtype() {
			const category = this.stream.type;
			let CategoryName = null;
			if(category == 'live'){
				CategoryName = 'Livestreams'
			}else if(category == 'scheduled'){
				CategoryName = 'Pre-recorded Streams'
			}else if(category == 'restream'){
				CategoryName = 'Multistreams'
			}
			return CategoryName;
		},
		stepBack() {
			this.stage--;

			this.clearErrors();
			this.resetPlatform();
		},
	
		dismiss() {
			this.hideLegacyModal();
			this.onDismiss();
		},
		
		onDismiss() {
			// clear up cache
			this.clearErrors();
			this.dismissCountDown = 0

			// lazy clear
			setTimeout(() => {
				this.stage = 0;
				this.processing = false;
			}, 1000);
		},
		clearErrors() {
			this.error = null;
			this.formErrors.server = false;
			this.formErrors.streamKey = false;
		},
		isChosen (stream) {
			return this.chosenStreams.find( streamFromArray => streamFromArray._id === stream._id)
		},
		toggleChoose(stream) {
			if (stream.added) return 
			// const chosenStreams = this.chosenStreams;
			const result = this.chosenStreams.find( ({ _id }) => _id === stream._id );
			if (!result ) {
				const addedStream = this.stream.platforms.find(({ streamObject }) => {
					if (streamObject) return streamObject._id === stream._id
				})
				if (addedStream) stream.added = true
				this.chosenStreams.push(stream);
			} else {
				let index;
				index = this.chosenStreams.indexOf(stream);
				this.chosenStreams = _.concat(
					this.chosenStreams.slice(0, index),
					this.chosenStreams.slice(index + 1)
				);
			}
			// console.log(this.chosenStreams.find(stream._id));
		},
		async fetchPlatformUsage() {
			// Use Vuex store for platform usage (prevents duplicates)
			const platformUsage = await this.$store.dispatch('PlatformUsage/getPlatformUsage', this.stream.type);
			if(platformUsage) this.platformUsage = platformUsage
		},
		async addWithinCast() {
			this.loading = true;
			this.chosenStreams.forEach(async (video) => {
				const payload = {
					template: 'custom',
					server: video.ingest.address,
					key: video.ingest.key,
					region: video.region.name,
					enabled: false,
					castrName: video.name,
					castrStream: true,
					streamObject: video._id
				};
				if (video.config && video.config.password) {
					payload.key += '?password=' + video.config.password;
				}
				// await StreamService.addStreamPlatform(this.stream._id, payload);
				if (!video.added) {
					try {
						await StreamService.addStreamPlatform(this.stream._id, payload);
						track(EVENTS.DESTINATION_ADDED, { isCastrStream: true });
						this.$emit('platform-saved', payload);
						this.$emit('chosen-streams', this.chosenStreams);
						// await StreamService.setStreamPlatformName(
						// 	this.stream._id,
						// 	video._id,
						// 	video.name
						// );
						this.dismiss();
						this.loading = false;
						video.added = true;
						const platformUsage = await StreamService.getPlatformUsage(this.stream.type);
						if(platformUsage) this.platformUsage = platformUsage;
					}
					catch(error) {
						// console.error(error.stack);
						// if (error.message === 'Please upgrade your subscription to add more streams and platforms.') {
						// 	return this.error = error;
						// }
						this.dismissCountDown = this.dismissSecs;
						this.loading = false;
					}
				}	else {
					this.loading = false;
					this.dismiss();
				}
			});
		},
		clearChosenStreams(e) {
			this.chosenStreams = [];
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.platform-list {
	max-height: calc(100% - 200px);
	overflow-y: auto;
	overflow-x: hidden;
	position: absolute;
}
.platform-list>li:empty {
	display: none;
}
.platform-item {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
	cursor: pointer;
}
.platform-item.active {
	background-color: var(--c-main-1);
}
.platform-icon img {
	max-height: 40px;
	object-fit: contain;
	margin-bottom: .5rem;
	width: 100%;
}
.platform-icon_secondary {
	max-height: 40px;
	object-fit: contain;
}
.second-modal {
		position: fixed;
		top: 0;
		background-color: var(--c-dark-2);
		margin: auto;
		width: 410px;
		height: 100%;
		-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
		   -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
		     -o-transition: opacity 0.3s linear, right 0.3s ease-out;
		        transition: opacity 0.3s linear, left 0.3s ease-out;
		left: 0;
		z-index: -1;
		border-left: 1px solid var(--c-dark-3);
		border-right: 1px solid var(--c-dark-3);
	}
	.showform.second-modal {
		left: 510px;
		
		-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
		   -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
		     -o-transition: opacity 0.3s linear, right 0.3s ease-out;
		        transition: opacity 0.3s linear, left 0.3s ease-out;
	}
#service-subchannels-dropdown .hint-upgrade {
   display: none;
}
#service-subchannels-dropdown .disabled .hint-upgrade {
   display: block;
}
.lined {
	position: relative;
	display: flex;
	align-content: center;
	justify-content: center;
	white-space: nowrap;
}
.lined:before {
	content: '';
	position: relative;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	top: 12px;
	margin-right: 10px;
}
.lined:after {
	content: '';
	position: relative;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	top: 12px;
	margin-left: 10px;
}
:deep( * .dropdown-menu_md, .tests)	{
	max-height: 300px;
	overflow-y: auto;
	max-width: 100%;
}
:deep(.page-item .dropdown-item) {
	white-space: normal;
}
.platform-label {
	text-transform: capitalize;
	text-align: center;
}
.add-platform-title {
	font-size: 20px;
}
.platform-item:hover {
	background-color: var(--c-dark-3);
}
.grid-wrapper {
	max-height: calc(100vh - 350px);
	overflow-x: hidden;
	overflow-y: auto;
}
:deep(.grid-item .castr-card) {
	margin-bottom: 0;
}
.search-form__toggle {
	z-index: 10;
}
@media (max-width: 767px) {
	.showform.second-modal {
		top: 70px;
		left: 0;
		z-index: 1030;
		max-width: 100%;
	}
}
</style>